import { html } from '@acme/b2b/utils';
import { AdvancedFiltersComponentModule, AdvancedFiltersService } from '@b2b/common/components/advanced-filters';
import { CartDirectiveModule } from '@b2b/common/directives';
import { GridDefinitionFactory } from '@b2b/common/factories/gridDefinition/types';
import { GridStateFactory } from '@b2b/common/factories/gridState/types';
import { NoticeFactory } from '@b2b/common/factories/notice';
import { CartService, CartServiceModule, ModalService, ModalServiceModule } from '@b2b/common/services';
import { ApiService } from '@b2b/common/services/api/types';
import { CalendarService } from '@b2b/common/services/calendar';
import { PermissionsService } from '@b2b/common/services/permissions';
import { SidebarService, SidebarServiceModule } from '@b2b/common/services/sidebar';
import { ThemesHelperService } from '@b2b/common/services/themesHelper';
import { UserPreferencesService } from '@b2b/common/services/userPreferences/types';
import { ColumnDef, LooseAutocomplete, Timestamp, TODO, UIBModal, UIBModalService } from '@b2b/types/core';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IFilterService, ISCEService, IScope, ITimeoutService } from 'angular';
import moment from 'moment-timezone';
import {
  createPrivateEventModalConfig,
  CreatePrivateEventModalControllerModule,
} from '../../modals/createPrivateEvent/controllers/CreatePrivateEventController';

export const ProgramsListControllerModule = angular
  .module('acme.view.application.programs.list.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.service.calendar',
    'acme.common.service.permissions',
    'acme.common.service.viewState',
    'acme.common.factory.notice',
    'acme.common.factory.gridState',
    'acme.common.factory.gridDefinition',
    SidebarServiceModule,
    'acme.common.service.userPreferences',
    'acme.common.service.templates.helpers',
    'acme.common.service.themesHelper',
    'acme.common.service.featureToggle',
    ModalServiceModule,
    CartServiceModule,
    CartDirectiveModule,
    AdvancedFiltersComponentModule,
    'acme.view.application.programs.createOrderModal.controllers',
    'acme.view.application.modals.confirmCustom.controllers',
    'acme.view.application.programs.instance.edit.cancelModal.controllers',
    'acme.view.application.programs.instance.edit.removeModal.controllers',
    'acme.view.application.programs.instance.edit.restoreModal.controllers',
    CreatePrivateEventModalControllerModule,
  ])
  .controller('ProgramsListController', [
    '$scope',
    '$state',
    '$filter',
    '$timeout',
    '$uibModal',
    'ModalService',
    '$sce',
    'ApiService',
    'CalendarService',
    'HelpersService',
    'PermissionsService',
    'SidebarService',
    'NoticeFactory',
    'GridStateFactory',
    'ViewStateService',
    'GridDefinitionFactory',
    'UserPreferencesService',
    'TemplatesHelpersService',
    'CustomFieldsData',
    'ThemesHelperService',
    'FeatureToggleService',
    'CartService',
    'AdvancedFiltersService',
    function (
      $scope: IScope & { programsList: TODO },
      $state: StateService,
      $filter: IFilterService,
      $timeout: ITimeoutService,
      $uibModal: UIBModalService,
      modalService: ModalService,
      $sce: ISCEService,
      ApiService: ApiService,
      CalendarService: CalendarService,
      HelpersService: TODO,
      PermissionsService: PermissionsService,
      sidebarService: SidebarService,
      NoticeFactory: NoticeFactory,
      GridStateFactory: GridStateFactory,
      ViewStateService: TODO,
      GridDefinitionFactory: GridDefinitionFactory,
      UserPreferencesService: UserPreferencesService,
      TemplatesHelpersService: TODO,
      CustomFieldsData: TODO,
      ThemesHelperService: ThemesHelperService,
      FeatureToggleService: TODO,
      CartService: CartService,
      advancedFiltersService: AdvancedFiltersService,
    ) {
      // Helper to format dates using tenant timezone instead of browser timezone
      const toTenantTimezoneISO = (date: Date): Timestamp => {
        const tenantTimezone = ThemesHelperService.getCompany('timezone');
        const targetTz = moment
          .tz(
            [date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()],
            tenantTimezone
          )
          .format('ZZ');
        return CalendarService.toTZISO8601(date, targetTz);
      };

      const ctrl = {
        cartService: CartService,

        gridDefinition: new GridDefinitionFactory(),

        selected: false as
          | {
              id: number;
              level: any;
              tickets: any[];
              event:
                | {
                    priceList: { prices: any[] };
                  }
                | false;
            }
          | false,
        isLoaded: false,
        showFullDetails: false,

        analytics: undefined,

        eventRequest: false,
        isCSR: false,
        actionItemsSet: false,
        userPreferencesLoaded: false,
        viewId: '',

        addModal: {} as UIBModal<any>,
        createModal: {} as UIBModal<any>,
        showMessageModal: {} as UIBModal<any>,
        privateEventModal: {} as UIBModal<any>,

        startDate: '' as Timestamp | Date,
        endTime: '' as Timestamp | Date,
        startTime: '' as Timestamp | Date,
        searchQuery: '',

        model: [] as any[],
        typed: [] as any[],
        filtered: [] as any[],
        notice: new NoticeFactory(),

        emailSetting: 'always',
        company: ThemesHelperService.getCompany(),

        customFields: [] as any[],
        advancedFiltersFields: [] as any[],
        paramsCustomFields: {
          operator: 'and',
          fields: [] as any[],
        },

        gridState: new GridStateFactory(),

        pageSize: 50,
        eventListGridName: $state.current.name + '.grid0',
        startingDay: UserPreferencesService.getStartDayOfWeek(),
        dateFormat: UserPreferencesService.getDateFormat('shortDate', 'dateFormat'),
        headerDateFormat: UserPreferencesService.getDateFormat('extendedDate', 'dateFormat'),
        hourFormat: UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),

        searchEventType: {},

        eventTypes: [
          {
            name: 'all',
            label: 'All events',
          },
          {
            name: 'private',
            label: 'Partner events',
          },
          {
            name: 'offSchedule',
            label: 'Events from order requests',
          },
        ],

        resourceRequests: {},

        resourceRequestTypes: [
          {
            name: 'all',
            label: 'With/Without requests',
          },
          {
            name: 'any',
            label: 'At least one request',
          },
          {
            name: 'none',
            label: 'No requests',
          },
        ],

        // TODO: Check why are there 2 different spellings for 'canceled'
        showListType: {} as { name: LooseAutocomplete<'active' | 'suspended' | 'canceled' | 'cancelled' | 'deleted'> },

        listTypes: [
          {
            name: 'active',
            label: 'Active',
            notes: '(includes suspended events)',
          },
          {
            name: 'canceled',
            label: 'Canceled',
            notes: '',
          },
          {
            name: 'deleted',
            label: 'Deleted',
            notes: '',
          },
          {
            name: 'suspended',
            label: 'Suspended',
            notes: '',
          },
        ],

        analyticsDateType: {},

        analyticsDateTypes: [
          {
            name: 'revenueForDate',
            label: 'Selected Date',
          },
          {
            name: 'revenueToday',
            label: 'Today',
          },
          {
            name: 'revenueLastSevenDays',
            label: 'Last Week',
          },
          {
            name: 'revenueNextSevenDays',
            label: 'Next Week',
          },
        ],

        optionsOverride: {
          data: 'programsList.model',
          rowClasses: `{ 'ui-grid-row-header-cell': col.isRowHeader, 'private-event': (row.entity.type === 'private') || row.entity.offSchedule, 'programs-list-canceled-row': (row.entity.showCanceledState && row.entity.isCanceled) }`,
          getRowClass: function (params) {
            if (params.data.type === 'private' || params.data.offSchedule) {
              return 'private-event';
            } else if (params.data.isCanceled && params.data.showCanceledState) {
              return 'programs-list-canceled-row';
            } else {
              return null;
            }
          },
          columnDefs: [
            {
              field: 'view',
              displayName: 'View',
              width: 50,
              onCellNavClick: function (row, col) {
                ctrl.optionsOverride.appScopeProvider.onDblClick(row);
              },
              cellTemplate: html`
                <div class="ui-grid-cell-contents text-center">
                  <span data-ng-style="row.entity.colorCategoryStyle"></span>
                  <a data-ng-click="grid.appScope.onDblClick(row)" role="link">
                    View<span class="sr-only"> Details for {{ row.entity.name }}</span>
                  </a>
                </div>
              `,
              visible: true,
              enableHiding: false,
              enableSorting: false,
              suppressSizeToFit: true,
            },
            {
              field: 'admissionType',
              displayName: 'Type',
              headerTooltip: true,
              width: 30,
              cellTemplate: html`
                <div class="ui-grid-cell-text" ng-class="col.colIndex()">
                  <span title="Suspended event" data-ng-show="row.entity.isSuspended">
                    <span
                      class="fa fa-exclamation-triangle programs-list-admin-admission-type suspended"
                      role="presentation"></span>
                    <span class="sr-only">Suspended event</span>
                  </span>
                  <span
                    title="Template: {{ row.entity.name }}"
                    data-ng-show="row.entity.fieldStatus.modified && !row.entity.isSuspended">
                    <span class="fa fa-unlink programs-list-admin-admission-type" role="presentation"> </span>
                    <span class="sr-only">Unlinked from template</span>
                  </span>
                  <span
                    title="General Admission"
                    data-ng-show="!row.entity.fieldStatus.modified && row.entity.admissionType === 'generalAdmission' && !row.entity.isSuspended">
                    <span class="fa fa-asterisk programs-list-admin-admission-type" role="presentation"></span>
                    <span class="sr-only">General admission template</span>
                  </span>
                </div>
              `,
              cellRenderer: function (params) {
                if (params.data.isSuspended) {
                  return html`
                    <div class="ui-grid-cell-text" ng-class="col.colIndex()">
                      <span title="Suspended event">
                        <span
                          class="fa fa-exclamation-triangle programs-list-admin-admission-type suspended"
                          role="presentation"></span>
                        <span class="sr-only">Suspended event</span>
                      </span>
                    </div>
                  `;
                }

                if (params.data.fieldStatus.modified) {
                  return html`
                    <div class="ui-grid-cell-text" ng-class="col.colIndex()">
                      <span title="Template: ${params.data.name}">
                        <span class="fa fa-unlink programs-list-admin-admission-type" role="presentation"></span>
                        <span class="sr-only">Unlinked from template</span>
                      </span>
                    </div>
                  `;
                }

                if (params.data.admissionType === 'generalAdmission') {
                  return html`
                    <div class="ui-grid-cell-text" ng-class="col.colIndex()">
                      <span title="General Admission">
                        <span class="fa fa-asterisk programs-list-admin-admission-type" role="presentation"></span>
                        <span class="sr-only">General admission template</span>
                      </span>
                    </div>
                  `;
                }

                return html`<div class="ui-grid-cell-text" ng-class="col.colIndex()"></div>`;
              },
              visible: true,
              enableHiding: false,
              suppressSizeToFit: true,
            },
            {
              field: 'id',
              displayName: 'Event Id',
              visible: false,
            },
            {
              field: 'formattedStartTime',
              displayName: 'Start Time',
              width: 90,
              colId: 'startTime',
              sort: {
                direction: 'asc',
              },
            },
            {
              field: 'name',
              displayName: 'Event Name',
              visible: true,
            },
            {
              field: 'organization.name',
              displayName: 'Organization Name',
              visible: false,
            },
            {
              field: 'scheduleName',
              displayName: 'Schedule Name',
              visible: true,
            },
            {
              field: 'resourceRequestDisplay',
              displayName: 'Resources',
              visible: true,
              minWidth: 150,
              colId: 'requestSummary',
            },
            {
              field: 'sold',
              displayName: 'Sold',
              width: 60,
              visible: true,
            },
            {
              field: 'reserved',
              displayName: 'Reserved',
              width: 80,
              visible: true,
            },
            {
              field: 'available',
              displayName: 'Available',
              width: 80,
              visible: true,
            },
            {
              field: 'checkedIn',
              displayName: 'Checked In',
              width: 90,
              visible: true,
            },
          ] as ColumnDef[],
          appScopeProvider: {
            onDataGridPaginate: function (newPageNumber, newPageSize, sortField, sortDirection) {
              ctrl.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
            },
            onDataGridSortChange: function (grid, columns, page) {
              ctrl.onDataGridSortChange(grid, columns, page);
            },
            onDblClick: function (item) {
              ctrl.onDblClick(item);
            },
            cancel: function (id, row) {
              ctrl.cancel(id, row);
            },
            createOrder: function (id, item) {
              ctrl.createOrder(id, item);
            },
            listAdminBooking: function (id) {
              ctrl.listAdminBooking(id);
            },
            remove: function (id) {
              ctrl.remove(id);
            },
            restore: function (id) {
              ctrl.restore(id);
            },
            onDataGridSelectionChange: function (row, e) {
              $scope.$emit('Cart::Close');
              if (ctrl.useCart && ctrl.showDetails) {
                ctrl.onDataGridSelectionChange(row, e);
              }
            },
          },
        },

        paramTemplateName: $state.params.templateName || '',
        paramTemplateId: $state.params.templateId || '',
        paramStartTime: $state.params.startTime || '',

        useCart: false,
        showDetails: false,

        cartEvents: [] as any[],

        init: function () {
          const startDate = ctrl.getToday();
          const endTime = new Date();

          endTime.setHours(23);
          endTime.setMinutes(59);
          endTime.setSeconds(59);

          ctrl.showListType = ctrl.initListType();

          ctrl.isCSR = PermissionsService.check('CSR');
          ctrl.viewId = $state.current.name ?? '';

          ctrl.useCart = FeatureToggleService.check('TENANT_CART');

          if (ctrl.useCart) {
            ctrl.cartService.getCart().then(ctrl.success.getCart, ctrl.error.getCart);
          }

          if (CustomFieldsData.data && CustomFieldsData.data.success) {
            ctrl.setCustomFields(CustomFieldsData);
          }

          ctrl.setListActionIcons();

          ctrl.gridDefinition.init(
            ctrl.eventListGridName,
            ctrl.optionsOverride,
            ctrl.viewId,
            $state.current.data.enablePreferences,
          );

          if (
            CalendarService.current.eventsStartTimeTracker &&
            CalendarService.current.eventsStartTimeTracker instanceof Date
          ) {
            this.startDate = new Date(
              CalendarService.current.eventsStartTimeTracker.getFullYear(),
              CalendarService.current.eventsStartTimeTracker.getMonth(),
              CalendarService.current.eventsStartTimeTracker.getDate(),
              0,
              0,
              0,
            );
          } else {
            this.startDate = startDate;
          }
          this.startTime = toTenantTimezoneISO(this.startDate as Date);
          this.endTime = toTenantTimezoneISO(endTime);

          $scope.$emit('Application::contentTitleChange', {
            title: 'Events List',
            buttonRight: {
              label: '+ Private Event',
              action: function () {
                ctrl.createPrivateEvent();
              },
            },
          });

          $scope.$on('pageContent::startLoad', function (event, data) {
            let startDate;

            if (data && data.from && data.from.name === 'application.programs.list') {
              switch (data.to.name) {
                case 'application.programsInstance':
                case 'application.orders.checkout':
                case 'application.programs.listAdminBooking':
                case 'application.programs.listAdminOrder':
                case 'application.scheduler.detail':
                case 'application.cart':
                  break;

                default:
                  startDate = ctrl.getToday();
                  CalendarService.current.eventsStartTimeTracker = null;
                  ctrl.startDate = startDate;

                  ViewStateService.resetState('programs.create.order.modal.accounts');
              }
            }
          });

          this.getNotificationPreference();

          $scope.$watch('programsList.startDate', this.onStartDateUpdate);
          $scope.$watch('programsList.searchEventType', this.onSearchEventTypeUpdate);
          $scope.$watch('programsList.searchRequestType', this.onSearchRequestTypeUpdate);

          $scope.$on('$destroy', $scope.$on('DataGrid::UserPreferencesLoaded', this.initData));
          $scope.$on('$destroy', $scope.$on('UserPreferencesService:onDateFormatLoad', this.onDateFormatLoad));

          $scope.$on('$destroy', $scope.$watch('programsList.cartService.initted', this.onCartServiceInitted));
          $scope.$on(
            '$destroy',
            $scope.$watch('programsList.cartService.events.events.length', this.onCartServiceInitted),
          );

          $scope.$on('$destroy', function () {
            CalendarService.current.eventsStartTimeTracker = ctrl.startDate;
          });
        },

        initData: function (e, data) {
          const props = ctrl.gridDefinition.getGridState();
          ctrl.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
          ctrl.search();
        },

        initListType: function () {
          let result = ctrl.listTypes[0]; // [0]: actives, by default

          if (ctrl.paramTemplateId) {
            result = ctrl.listTypes[1]; // [1]: deleted
          }

          return result;
        },

        getNotificationPreference: function () {
          if (this.company.hasOwnProperty('notificationPreference')) {
            this.emailSetting = this.company.notificationPreference;
          }
        },

        setCustomFields: function (customFieldsData) {
          const list = customFieldsData.data.payload.list;
          let atIndex = this.optionsOverride.columnDefs.length;

          this.customFields = list;
          this.advancedFiltersFields = advancedFiltersService.mapCustomFieldsToAdvancedFiltersFields(this.customFields);

          //ideally insert at after "scheduleName", Otherwise at end
          for (let i = 0, ii = this.optionsOverride.columnDefs.length; i < ii; i++) {
            if (this.optionsOverride.columnDefs[i].field === 'resourceRequestDisplay') {
              atIndex = i;
              break;
            }
          }
          angular.forEach(list, function (customField, key) {
            ctrl.optionsOverride.columnDefs.splice(atIndex, 0, {
              field: customField.internalLabel,
              displayName: customField.label,
              visible: false,
            });
            atIndex++;
          });
        },

        setListActionIcons: function () {
          ctrl.optionsOverride.columnDefs.splice(3, 0, {
            field: 'startDate',
            displayName: 'Date',
            width: 80,
            visible: false,
            cellFilter: 'date: "' + ctrl.dateFormat + '"',
            cellFormatter: function (item) {
              return CalendarService.toFormat(item.value, ctrl.dateFormat);
            },
          } as TODO);

          if (PermissionsService.check(['ORDER_CREATE', 'ACCT_ORDERS_CREATE'])) {
            ctrl.optionsOverride.columnDefs.push({
              field: 'order',
              displayName: 'Order',
              headerTooltip: true,
              width: 40,
              cellClass: 'programs-list-grid-cell',
              onCellNavClick: function (row, col) {
                if (!row.entity.offSchedule && !row.entity.addedToCart) {
                  ctrl.optionsOverride.appScopeProvider.createOrder(row.entity.id, row.entity);
                }
              },
              cellTemplate: html`
                <div class="ui-grid-cell-text" ng-class="col.colIndex()">
                  <a
                    class="programs-list-link programs-list-manual-entry"
                    title="Create Order"
                    data-ng-show="!row.entity.offSchedule && !row.entity.addedToCart"
                    data-ng-class="{ 'programs-list-link-disabled': row.entity.manuallyDeleted }"
                    data-ng-click="grid.appScope.createOrder(row.entity.id)">
                    <span class="fa fa-ticket" role="presentation"></span>
                    <span class="sr-only"> Create order for {{ row.entity.name }} - Opens Dialog </span>
                  </a>
                  <a
                    class="programs-list-link programs-list-link-disabled programs-list-manual-entry"
                    title="Added to cart"
                    data-ng-show="!row.entity.offSchedule && row.entity.addedToCart">
                    <span class="fa fa-check" role="presentation"></span>
                    <span class="sr-only">{{ row.entity.name }} added to cart</span>
                  </a>
                </div>
              `,
              visible: true,
              enableHiding: false,
              suppressSizeToFit: true,
              enableSorting: false,
            });
          }

          if (PermissionsService.check('ORDER_REBOOK')) {
            ctrl.optionsOverride.columnDefs.push({
              field: 'booking',
              displayName: 'Rebook',
              headerTooltip: true,
              width: 40,
              cellClass: 'programs-list-grid-cell',
              onCellNavClick: function (row, col) {
                if (!row.entity.offSchedule) {
                  ctrl.optionsOverride.appScopeProvider.listAdminBooking(row.entity.id);
                }
              },
              cellTemplate: html`
                <div class="ui-grid-cell-text" ng-class="col.colIndex()">
                  <a
                    title="Rebook"
                    role="button"
                    data-ng-hide="row.entity.offSchedule"
                    class="programs-list-link programs-list-rebook"
                    data-ng-class="{'programs-list-link-disabled': row.entity.manuallyDeleted}"
                    data-ng-click="grid.appScope.listAdminBooking(row.entity.id)">
                    <span class="fa fa-calendar" role="presentation"></span>
                    <span class="sr-only">Rebook {{ row.entity.name }}</span>
                  </a>
                </div>
              `,
              visible: true,
              enableHiding: false,
              suppressSizeToFit: true,
              enableSorting: false,
            });
          }

          if (PermissionsService.check(['EVENT_CANCEL'])) {
            ctrl.optionsOverride.columnDefs.push({
              field: 'cancel',
              displayName: 'Cancel',
              headerTooltip: true,
              width: 40,
              cellClass: 'programs-list-grid-cell',
              onCellNavClick: function (row, col) {
                ctrl.optionsOverride.appScopeProvider.cancel(row.entity.id, row);
              },
              cellTemplate: html`
                <div class="ui-grid-cell-text" ng-class="col.colIndex()">
                  <a
                    title="Cancel"
                    role="button"
                    class="programs-list-link programs-list-cancel"
                    data-ng-class="{'programs-list-link-disabled': row.entity.manuallyDeleted}"
                    data-permit="EVENT_CANCEL"
                    data-ng-click="grid.appScope.cancel(row.entity.id, row)">
                    <i role="presentation" class="fa fa-ban"></i>
                    <span class="sr-only">Cancel {{ row.entity.name }} - Opens Dialog</span>
                  </a>
                </div>
              `,
              visible: true,
              enableHiding: false,
              suppressSizeToFit: true,
              enableSorting: false,
            });
          }

          if (PermissionsService.check(['EVENT_DELETE', 'EVENT_RESTORE'])) {
            ctrl.optionsOverride.columnDefs.push({
              field: 'delete',
              displayName: 'Delete',
              headerTooltip: true,
              width: 40,
              cellClass: 'programs-list-grid-cell',
              onCellNavClick: function (row, col) {
                if (row.entity.manuallyDeleted && !row.entity.offSchedule) {
                  ctrl.optionsOverride.appScopeProvider.restore(row.entity.id);
                } else if (!row.entity.offSchedule) {
                  ctrl.optionsOverride.appScopeProvider.remove(row.entity.id);
                }
              },
              cellTemplate: html`
                <div
                  class="ui-grid-cell-text"
                  ng-class="col.colIndex()"
                  data-ng-show="!row.entity.manuallyDeleted && !row.entity.offSchedule">
                  <a
                    title="Remove"
                    role="button"
                    class="programs-list-link programs-list-remove"
                    data-permit="EVENT_DELETE"
                    data-ng-click="grid.appScope.remove(row.entity.id)">
                    <i role="presentation" class="fa fa-times-circle-o"></i>
                    <span class="sr-only">Delete {{ row.entity.name }} - Opens Dialog</span>
                  </a>
                </div>
                <div
                  class="ui-grid-cell-text"
                  ng-class="col.colIndex()"
                  data-ng-show="row.entity.manuallyDeleted && !row.entity.offSchedule">
                  <a
                    title="Restore"
                    role="button"
                    class="programs-list-link programs-list-remove"
                    data-permit="EVENT_RESTORE"
                    data-ng-click="grid.appScope.restore(row.entity.id)">
                    <i role="presentation" class="fa fa-undo"></i>
                    <span class="sr-only">Restore {{ row.entity.name }} - Opens Dialog</span>
                  </a>
                </div>
              `,
              visible: true,
              enableHiding: false,
              suppressSizeToFit: true,
              enableSorting: false,
            });
          }
        },

        setListActionIconVisibility: function (listType) {
          if (listType) {
            switch (listType) {
              case 'canceled':
                this.gridDefinition.setColumnVisibility({
                  order: false,
                  delete: false,
                  cancel: false,
                  booking: false,
                });
                break;
              case 'deleted':
                this.gridDefinition.setColumnVisibility({
                  order: false,
                  delete: PermissionsService.check(['EVENT_DELETE', 'EVENT_RESTORE']),
                  cancel: false,
                  booking: false,
                });
                break;
              default:
                this.gridDefinition.setColumnVisibility({
                  order: PermissionsService.check(['ORDER_CREATE', 'ACCT_ORDERS_CREATE']),
                  delete: PermissionsService.check(['EVENT_DELETE', 'EVENT_RESTORE']),
                  cancel: PermissionsService.check(['EVENT_CANCEL']),
                  booking: PermissionsService.check('ORDER_REBOOK'),
                });
                break;
            }
          }
        },

        isShowDeletedEvents: function () {
          return ctrl.showListType && ctrl.showListType.name === 'deleted';
        },

        isShowCanceledEvents: function () {
          return ctrl.showListType && ctrl.showListType.name === 'canceled';
        },

        getEvents: function () {
          const params: {
            startTime: Timestamp;
            endTime: Timestamp;
            saleChannel?: string;
            resourceRequestFilter?: string;
            filter?: string;
            customFields?: string;
            states?: string;
          } = {
            startTime: this.startTime as Timestamp,
            endTime: this.endTime as Timestamp,
          };

          this.gridState.setPropertyValue('search', this.searchQuery);

          if (this.isCSR) {
            params.saleChannel = 'customerRep';
          }
          if (this.searchRequestType.name) {
            params.resourceRequestFilter = this.searchRequestType.name;
          }
          if (this.searchEventType.name && this.searchEventType.name === 'offSchedule') {
            params.filter = this.searchEventType.name;
          }

          if (this.paramsCustomFields.fields && this.paramsCustomFields.fields.length) {
            params.customFields = this.paramsCustomFields;
          }

          switch (this.showListType.name) {
            case 'all':
              params.states = 'active,suspended,cancelled';
              break;
            case 'canceled':
              params.states = 'cancelled';
              break;
            case 'suspended':
              params.states = 'suspended';
              break;
            default:
              params.states = 'active,suspended';
              break;
          }

          console.log('ProgramsListController::getEvents', this.startTime, this.endTime);
          ApiService.event
            .search($.extend(params, this.gridState.getGridState()))
            .then(this.success.getEvents, this.error.getEvents);
        },

        getCanceledEvents: function () {
          this.gridState.setPropertyValue('search', this.searchQuery);

          console.log('ProgramsListController::getCanceledEvents', this.startTime, this.endTime);
          ApiService.event
            .canceled(this.startTime, this.endTime, this.gridState.getGridState())
            .then(this.success.getCanceledEvents, this.error.getCanceledEvents);
        },

        getDeletedEvents: function () {
          const props: { startTime: Timestamp; templateId?: string; endTime?: Timestamp; requestFilter?: string } = {
            startTime: this.paramStartTime || this.startTime,
          };

          this.gridState.setPropertyValue('search', this.searchQuery);

          //paramTemplateId is only set when you are coming into this view from a different page.
          //in this case don't send end time.
          if (this.paramTemplateId) {
            props.templateId = this.paramTemplateId;
            console.log('ProgramsListController::getDeletedEvents', this.startTime, this.endTime);
          }
          //Get the deleted events for current date and time from events list page.
          else {
            props.endTime = this.endTime;
            console.log('ProgramsListController::getDeletedEvents', this.startTime, this.endTime);
          }
          if (this.searchRequestType.name) {
            props.requestFilter = this.searchRequestType.name;
          }
          ApiService.program.trash
            .list(props, this.gridState.getGridState())
            .then(this.success.getDeletedEvents, this.error.getDeletedEvents);
        },

        getAnalytics: function () {
          ApiService.analytics.revenue
            .summary(CalendarService.toFormat(this.startDate, 'yyyy-MM-dd'))
            .then(this.success.getAnalytics, this.error.getAnalytics);
        },

        hasAnalytics: function () {
          return this.analytics && this.analytics.revenueToday;
        },

        selectEvent: function () {
          if (this.model.length) {
            if (this.membershipId && this.model.length > 1) {
              this.gridDefinition.selectRows([this.model[1]]);
            } else {
              this.gridDefinition.selectRows([this.model[0]]);
            }
          } else {
            this.gridDefinition.clearSelection();
            this.selected = false;
          }
        },

        getEvent: function (event) {
          ApiService.event.detail(event.id).then(this.success.getEvent, this.error.getEvent);
        },

        getEventTickets: function () {
          if (this.selected.event) {
            this.selected.tickets = this.selected.event.priceList.prices;
            this.updateSelection();
            //TODO: Restore quantities from the cart.
          }
        },

        getAnalyticsAmount: function (type) {
          let result = 0;
          if (this.analytics.hasOwnProperty(type)) {
            result = this.analytics[type].amount || 0;
          }
          return result;
        },

        getAnalyticsQuantity: function (type) {
          let result = 0;
          if (this.analytics.hasOwnProperty(type)) {
            result = this.analytics[type].quantity || 0;
          }
          return result;
        },

        reduce: function () {
          // Next tick
          $timeout(function () {
            ctrl.filtered = $filter('filter')(ctrl.typed, function (event) {
              const name = event.name || '';
              const value = name.toLowerCase();

              return value.indexOf(ctrl.searchQuery.toLowerCase()) !== -1 ? event : null;
            });
          }, 0);
        },

        query: function () {
          ctrl.gridState.setPropertyValue('search', ctrl.searchQuery);
          $scope.$broadcast('DataGrid::Search', { name: ctrl.eventListGridName });
        },

        search: function () {
          this.isLoaded = false;
          if (this.gridDefinition.userPreferencesLoaded) {
            if (this.isShowDeletedEvents()) {
              this.getDeletedEvents();
            } else {
              this.getEvents();
            }
          }
        },

        updateSelection: function () {
          let selectedEvent;

          if (ctrl.selected && ctrl.selected.tickets.length) {
            selectedEvent = ctrl.cartEvents.filter((event) => {
              return ctrl.selected && event.eventId === ctrl.selected.id;
            });

            if (selectedEvent.length && selectedEvent[0].tickets.length) {
              ctrl.selected.tickets.forEach((ticket) => {
                for (let i = 0, ii = selectedEvent[0].tickets.length; i < ii; i++) {
                  if (selectedEvent[0].tickets[i].ticketingTypeId === ticket.personType.id) {
                    ticket.quantity = selectedEvent[0].tickets[i].quantity;
                    ticket.itemId = selectedEvent[0].tickets[i].itemId;
                  }
                }
              });
            }
          }
        },

        refresh: function () {
          ctrl.cartEvents = ctrl.cartService.events.getEvents();
          if (ctrl.showDetails) {
            ctrl.updateSelection();
          }
          ctrl.updateEventsInCart();
        },

        updateEventsInCart: function () {
          if (ctrl.useCart) {
            ctrl.model.forEach((event) => {
              event.addedToCart = ctrl.cartService.events.getById(event.id);
            });
          }
        },

        addToCart: function (event) {
          CartService.events.addToCart(event).then(this.success.addEventToCart, this.error.addEventToCart);
        },

        createCheckoutOrder: function (id, event) {
          ctrl.createModal = $uibModal.open({
            templateUrl: 'views/application/views/programs/modals/createOrderModal.tpl.html',
            size: 'md',
            controller: 'ProgramsCreateOrderModalController',
            resolve: {
              currentEvent: () => event.instance,
            },
          });

          ctrl.createModal.result
            .then((response) => {
              ctrl.notice.hideSuccessMessages();
              ctrl.notice.hideErrorMessages();

              if (response.type === 'manual') {
                CalendarService.current.eventsStartTimeTracker = ctrl.startDate;
                $state.go('application.programs.listAdminOrder', { id: id });
              } else if (response.type === 'retail') {
                CalendarService.current.eventsStartTimeTracker = ctrl.startDate;
                $state.go('application.orders.checkout', { eventId: id });
              } else if (response.type === 'account') {
                CalendarService.current.eventsStartTimeTracker = ctrl.startDate;
                $state.go('application.orders.checkout', { eventId: id, accountId: response.accountId });
              }
            })
            .catch(() => {
              // noop
            });
        },

        createOrder: function (id, item) {
          const event = ctrl.findEvent(id);

          const upgradeDowngradeMembership = CartService.memberships.getUpgradeDowngradeMembership();
          const hasUpgradeDowngradeMembership = !!upgradeDowngradeMembership.length;

          if (event && !event.instance.manuallyDeleted && !event.instance.offSchedule) {
            if (hasUpgradeDowngradeMembership) {
              ctrl.showMessageModal = $uibModal.open({
                templateUrl: 'common/views/modals/confirm/confirm.tpl.html',
                size: 'md',
                controller: 'ConfirmCustomModalController',
                resolve: {
                  modalTitle: () => 'Are you sure?',
                  modalMessage: () =>
                    'Please add membership and tickets separately. Once you Upgrade / Downgrade, tickets will reflect applicable benefits. ',
                  okText: () => 'Buy Tickets First',
                  cancelText: () => 'Upgrade / Downgrade Membership First',
                  hideOkText: () => false,
                },
              });

              ctrl.showMessageModal.result.then(() => {
                CartService.removeItem(upgradeDowngradeMembership[0].itemId).then(() => {
                  ctrl.proceedToOrder(id, event);
                });
              });
            } else if (event.instance.isSuspended) {
              modalService
                .confirm({
                  title: 'Suspended Event',
                  message: 'You are creating an order for a suspended event, are you sure you want to continue?',
                  okText: 'Proceed',
                })
                .then(() => {
                  ctrl.proceedToOrder(id, event);
                });
            } else {
              ctrl.proceedToOrder(id, event);
            }
          }
        },

        createPrivateEvent: function () {
          ctrl.privateEventModal = $uibModal.open(
            createPrivateEventModalConfig(() => {
              return {
                startTime: ctrl.startTime,
                accountId: null,
                accountCategoryRelation: null,
              };
            }),
          );

          ctrl.privateEventModal.result.then(() => {
            ctrl.search();
          });
        },

        proceedToOrder: function (id, event) {
          if (this.useCart) {
            this.addToCart(event.instance);
          } else {
            this.createCheckoutOrder(id, event);
          }
        },

        listAdminBooking: function (id) {
          const event = ctrl.findEvent(id);

          if (event && !event.instance.manuallyDeleted && !event.instance.offSchedule) {
            if (event.instance.isSuspended) {
              modalService
                .confirm({
                  title: 'Suspended Event',
                  message: 'You are editing an order for a suspended event, are you sure you want to continue?',
                  okText: 'Proceed',
                })
                .then(() => {
                  ctrl.proceedToListAdminBooking(id);
                });
            } else {
              ctrl.proceedToListAdminBooking(id);
            }
          }
        },

        proceedToListAdminBooking: function (id) {
          CalendarService.current.eventsStartTimeTracker = ctrl.startDate;
          $state.go('application.programs.listAdminBooking', { id: id });
        },

        copyEventTypes: function () {
          this.typed = [];
          for (let i = 0, ii = this.model.length; i < ii; i++) {
            const event = this.model[i];
            const name = event.name || '';
            const value = name.toLowerCase();

            if (value.indexOf(this.searchQuery.toLowerCase()) !== -1) {
              if (this.searchEventType.name === 'all' || this.searchEventType.name === event.type) {
                this.typed.push(event);
              }
            }
          }
        },

        findEvent: function (id) {
          let result: { index: number; instance: any } | false = false;

          for (let i = 0, ii = this.model.length; i < ii; i++) {
            if (this.model[i].id === id) {
              result = {
                index: i,
                instance: this.model[i],
              };
            }
          }
          return result;
        },

        cancel: function (id, row) {
          const event = ctrl.findEvent(id);

          if (event && !event.instance.manuallyDeleted) {
            console.log(event, row);
            ctrl.addModal = $uibModal.open({
              templateUrl: 'views/application/views/programs/instance/edit/modals/cancelEvent.tpl.html',
              size: 'md',
              controller: 'ProgramsInstanceEditCancelModalController',
              resolve: {
                currentEvent: () => event.instance,
                emailSetting: () => ctrl.emailSetting,
              },
            });

            ctrl.addModal.result
              .then((data) => {
                const props = {
                  id: event.instance.id,
                  sendEmail: data.sendEmail || false,
                  sendEmailToResources: data.sendEmailToResources || false,
                  emailMessage: data.emailMessage || '',
                };

                ctrl.notice.hideSuccessMessages();
                ctrl.notice.hideErrorMessages();

                ctrl.model[event.index].isCanceled = true;
                ctrl.model[event.index].showCanceledState = !ctrl.isShowCanceledEvents();

                ApiService.program.cancel.event(props).then(ctrl.success.cancel, ctrl.error.cancel);
              })
              .catch(() => {
                // noop
              });
          }
        },

        remove: function (id) {
          const event = ctrl.findEvent(id);

          if (event && !event.instance.offSchedule) {
            ctrl.addModal = $uibModal.open({
              templateUrl: 'views/application/views/programs/instance/edit/modals/removeEvent.tpl.html',
              size: 'md',
              controller: 'ProgramsInstanceEditRemoveModalController',
              resolve: {
                currentEvent: () => event.instance,
                SoldQuantity: () => event.instance.sold,
                emailSetting: () => ctrl.emailSetting,
              },
            });

            ctrl.addModal.result
              .then((sendEmail) => {
                const props = {
                  id: event.instance.id,
                  sendEmail: sendEmail,
                };
                ctrl.notice.hideSuccessMessages();
                ctrl.notice.hideErrorMessages();

                ctrl.model[event.index].manuallyDeleted = true;
                ApiService.program.instances.remove(props).then(ctrl.success.remove, ctrl.error.remove);
              })
              .catch(() => {
                // noop
              });
          }
        },

        getToday: function () {
          const date = new Date();
          date.setHours(0);
          date.setMinutes(0);
          date.setSeconds(0);
          return date;
        },

        isToday: function () {
          const today = this.getToday();
          const date = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0).getTime();
          const startDate = new Date(
            this.startDate.getFullYear(),
            this.startDate.getMonth(),
            this.startDate.getDate(),
            0,
            0,
            0,
          ).getTime();

          return startDate === date;
        },

        today: function () {
          this.startDate = this.getToday();
        },

        next: function () {
          this.startDate = new Date(
            this.startDate.getFullYear(),
            this.startDate.getMonth(),
            this.startDate.getDate() + 1,
            0,
            0,
            0,
          );
        },

        previous: function () {
          this.startDate = new Date(
            this.startDate.getFullYear(),
            this.startDate.getMonth(),
            this.startDate.getDate() - 1,
            0,
            0,
            0,
          );
        },

        hasEvents: function () {
          let result = true;
          if (this.isLoaded) {
            result = this.filtered instanceof Array && this.filtered.length > 0;
          }
          return result;
        },

        process: function (events) {
          for (let i = 0, ii = events.length; i < ii; i++) {
            const startDate = CalendarService.parseDate(events[i].startTime);
            const endDate = CalendarService.parseDate(events[i].endTime);

            events[i].startDate = startDate;
            events[i].formattedEndTime = CalendarService.toFormat(endDate, this.hourFormat);
            events[i].formattedStartTime = CalendarService.toFormat(startDate, this.hourFormat);
            events[i].isCanceled = events[i].state && events[i].state === 'canceled' ? true : false;
            events[i].showCanceledState = !this.isShowCanceledEvents();
            events[i].resourceRequestDisplay = this.getEventRequestsDisplay(events[i]);
            if (events[i].colorCategory && events[i].colorCategory.textColor) {
              events[i].colorCategoryStyle = TemplatesHelpersService.getColorCategoryStyle(events[i].colorCategory);
            }

            events[i].isSuspended = events[i].state && events[i].state === 'suspended' ? true : false;

            if (events[i].offSchedule) {
              events[i].scheduleName = 'None (from Order Request)';
            }

            if (events[i].manuallyDeleted) {
              events[i].available = events[i].available || 0;

              if (!events[i].sold) {
                events[i].sold = events[i].soldQuantity || 0;
              }

              if (!events[i].checkedIn) {
                events[i].checkedIn = events[i].checkInCount || 0;
              }
            }

            for (let j = 0, jj = this.customFields.length; j < jj; j++) {
              events[i][this.customFields[j].internalLabel] = HelpersService.getCustomFieldValue(
                events[i],
                this.customFields[j].label,
              );
            }
          }

          return events;
        },

        processEvent: function (event) {
          event.thumbnail = this.getThumbnail(event);
          event.partialDescription = $sce.trustAsHtml(
            event.shortDescription
              ? HelpersService.strip(event.shortDescription, 300)
              : event.description
                ? HelpersService.strip(event.description, 300)
                : '',
          );
          event.longDescription = $sce.trustAsHtml(
            event.description ? event.description : event.shortDescription ? event.shortDescription : '',
          );

          return event;
        },

        getThumbnail: function (event) {
          let result = '';

          if (
            event &&
            event.images instanceof Array &&
            event.images.length &&
            event.images[0] &&
            event.images[0].thumbnail
          ) {
            result = event.images[0].thumbnail;
          } else {
            result = '/assets/img/global/no-image-landscape.png';
          }

          return result;
        },

        getEventRequestsDisplay: function (event) {
          let result = 'No requests';
          let personnelRequests = '';
          let equipmentRequests = '';
          let placesRequests = '';

          if (event.hasOwnProperty('requestSummary') && event.requestSummary.hasResourceRequests) {
            personnelRequests = this.getRequestsForCategory(event, 'people');
            equipmentRequests = this.getRequestsForCategory(event, 'equipment');
            placesRequests = this.getRequestsForCategory(event, 'place');

            if (personnelRequests || equipmentRequests || placesRequests) {
              result = personnelRequests || '';
              if (equipmentRequests) {
                result = result ? result + ', ' + equipmentRequests : equipmentRequests;
              }
              if (placesRequests) {
                result = result ? result + ', ' + placesRequests : placesRequests;
              }
            }
          }

          return result;
        },

        getRequestsForCategory: function (event, category) {
          let categorySuffix;
          let fulfilled = 0;
          let total = 0;
          let requests;
          let result = '';

          if (category === 'place') {
            categorySuffix = 'Places';
          } else {
            categorySuffix = HelpersService.cap(category);
          }

          if (event.requestSummary.hasOwnProperty(category)) {
            fulfilled = event.requestSummary[category].fulfilledRequestsCount
              ? event.requestSummary[category].fulfilledRequestsCount
              : 0;
            total = event.requestSummary[category].totalRequestsCount
              ? event.requestSummary[category].totalRequestsCount
              : 0;
            requests = total ? fulfilled + '/' + total : '';
            // Show resource name if total and fulfilled is 1 and only 1
            if (fulfilled === total && fulfilled === 1) {
              if (
                event.requestSummary[category].resourceNames instanceof Array &&
                event.requestSummary[category].resourceNames[0]
              ) {
                result = event.requestSummary[category].resourceNames[0];
              }
            } else {
              result = requests ? requests + ' ' + categorySuffix : '';
            }
          }

          return result;
        },

        launchScheduler: function () {
          CalendarService.current.eventsStartTimeTracker = ctrl.startDate;
          $state.go('application.scheduler.detail');
        },

        updateListType: function (n, o) {
          switch (this.showListType.name) {
            case 'deleted':
            case 'canceled':
              this.query();
              break;

            default:
              this.paramTemplateName = '';
              this.paramTemplateId = '';
              this.paramStartTime = '';
              this.query();
              break;
          }
          this.setListActionIconVisibility(this.showListType.name);
        },

        restore: function (id) {
          const event = ctrl.findEvent(id);

          if (event) {
            ctrl.addModal = $uibModal.open({
              templateUrl: 'views/application/views/programs/instance/edit/modals/restoreEvent.tpl.html',
              size: 'md',
              controller: 'ProgramsInstanceEditRestoreModalController',
              resolve: {
                currentEvent: () => event.instance,
              },
            });

            ctrl.addModal.result
              .then((name) => {
                ctrl.notice.hideSuccessMessages();
                ctrl.notice.hideErrorMessages();

                if (ctrl.showListType.name == 'deleted') {
                  ctrl.model.splice(event.index, 1);
                  ctrl.copyEventTypes();
                  ctrl.reduce();
                } else {
                  ctrl.model[event.index].manuallyDeleted = false;
                }

                ApiService.program.trash
                  .recover(event.instance.id)
                  .then((response) => ctrl.success.restore(response))
                  .catch((response) => ctrl.error.restore(response));
              })
              .catch(() => {
                // noop
              });
          }
        },

        onDateFormatLoad: function (e, data) {
          ctrl.startingDay = UserPreferencesService.getStartDayOfWeek();
          ctrl.dateFormat = UserPreferencesService.getDateFormat('shortDate', 'dateFormat');
          ctrl.headerDateFormat = UserPreferencesService.getDateFormat('extendedDate', 'dateFormat');
          ctrl.hourFormat = UserPreferencesService.getHourFormat();
        },

        showMessage: function (title, message) {
          if (message) {
            ctrl.showMessageModal = $uibModal.open({
              templateUrl: 'views/application/views/reports/create/modals/showMessage.tpl.html',
              size: 'md',
              controller: 'ReportsCreateShowMessageModalController',
              resolve: {
                currentTitle: () => title,
                currentMessage: () => message,
                safe: () => true,
              },
            });

            ctrl.showMessageModal.result.catch(() => {
              // noop
            });
          }
        },

        success: {
          getEvents: function (response) {
            ctrl.model = ctrl.process(response.data.payload.list);
            ctrl.copyEventTypes();
            ctrl.reduce();
            ctrl.updateEventsInCart();

            if (!$scope.$$phase) {
              $scope.$apply();
            }

            ctrl.isLoaded = true;
            ctrl.gridDefinition.isLoaded = true;
            $timeout(() => {
              $scope.$broadcast('DataGrid::ResizeGrid', {
                name: ctrl.gridDefinition.options.gridName,
                datasetLength: ctrl.model.length,
                totalItems: response.data.payload.pagination.count,
              });
              if (ctrl.showDetails) {
                ctrl.selectEvent();
              }
            }, 10);
          },

          getCanceledEvents: function (response) {
            console.log('ProgramsListController::success::getCanceledEvents', response);
            ctrl.model = ctrl.process(response.data.payload.list);
            ctrl.gridDefinition.isLoaded = true;
            ctrl.copyEventTypes();
            ctrl.reduce();
            ctrl.updateEventsInCart();

            if (!$scope.$$phase) {
              $scope.$apply();
            }

            ctrl.isLoaded = true;
            ctrl.gridDefinition.isLoaded = true;
            $timeout(() => {
              $scope.$broadcast('DataGrid::ResizeGrid', {
                name: ctrl.gridDefinition.options.gridName,
                datasetLength: ctrl.model.length,
                totalItems: response.data.payload.pagination.count,
              });
              if (ctrl.showDetails) {
                ctrl.selectEvent();
              }
            }, 10);
          },

          getDeletedEvents: function (response) {
            console.log('ProgramsListController::success::getDeletedEvents', response);
            ctrl.model = ctrl.process(response.data.payload.list);
            ctrl.gridDefinition.isLoaded = true;
            ctrl.copyEventTypes();
            ctrl.reduce();
            ctrl.updateEventsInCart();

            if (!$scope.$$phase) {
              $scope.$apply();
            }

            ctrl.isLoaded = true;
            ctrl.gridDefinition.isLoaded = true;
            $timeout(() => {
              $scope.$broadcast('DataGrid::ResizeGrid', {
                name: ctrl.gridDefinition.options.gridName,
                datasetLength: ctrl.model.length,
                totalItems: response.data.payload.pagination.count,
              });
              if (ctrl.showDetails) {
                ctrl.selectEvent();
              }
            }, 10);
          },

          getAnalytics: function (response) {
            ctrl.analytics = response.data.payload;
            ctrl.isLoaded = true;
          },

          cancel: function (response) {
            $scope.$broadcast('DataGrid::RefreshGrid');
          },

          remove: function (response) {
            $scope.$broadcast('DataGrid::RefreshGrid');
          },

          restore: function (response) {},

          addEventToCart: function (response) {
            $scope.$emit('Cart::Open');
          },

          getEvent: function (response) {
            if (ctrl.selected) {
              ctrl.selected.event = ctrl.processEvent(response.data.payload);
              ctrl.getEventTickets();
              ctrl.showFullDetails = false;
            }
          },

          getCart: function () {
            ctrl.refresh();
          },
        },

        error: {
          getEvents: function (response, status) {
            ctrl.isLoaded = status !== 'abort';
          },

          getCanceledEvents: function (response, status) {
            ctrl.isLoaded = true;
          },

          getDeletedEvents: function () {
            ctrl.isLoaded = true;
          },

          getAnalytics: function (response) {
            ctrl.isLoaded = true;
          },

          cancel: function (response) {},

          remove: function (response) {},

          restore: function (response) {},

          addEventToCart: function (response) {
            ctrl.showMessage('An error occurred', response.data.error);
          },

          getEvent: function (response) {
            if (ctrl.selected) {
              ctrl.selected.event = false;
            }

            ctrl.showFullDetails = false;
          },
          getCart: function () {
            ctrl.refresh();
          },
        },

        onStartDateUpdate: function (e, data) {
          const startDate = ctrl.startDate as Date;
          const endDate = new Date(ctrl.startDate);

          startDate.setHours(0);
          startDate.setMinutes(0);
          startDate.setSeconds(0);

          endDate.setHours(23);
          endDate.setMinutes(59);
          endDate.setSeconds(59);

          const startTime = toTenantTimezoneISO(startDate);
          ctrl.startTime = startTime;
          ctrl.endTime = toTenantTimezoneISO(endDate);

          ctrl.analyticsDateTypes[0].label = CalendarService.toFormat(ctrl.startDate, 'yyyy-MM-dd');

          ctrl.gridState.setPropertyValue('search', ctrl.searchQuery);
          $scope.$broadcast('DataGrid::Search', { name: ctrl.eventListGridName });
        },

        onSearchEventTypeUpdate: function (n, o) {
          if (n && o && n.name !== o.name) {
            ctrl.copyEventTypes();
            ctrl.reduce();
            ctrl.gridState.setPropertyValue('search', ctrl.searchQuery);
            $scope.$broadcast('DataGrid::Search', { name: ctrl.eventListGridName });
          }
        },

        onSearchRequestTypeUpdate: function (n, o) {
          if (n && o && n.name !== o.name) {
            ctrl.gridState.setPropertyValue('search', ctrl.searchQuery);
            $scope.$broadcast('DataGrid::Search', { name: ctrl.eventListGridName });
          }
        },

        onDblClick: function (item) {
          if (!item.entity.manuallyDeleted) {
            CalendarService.current.eventsStartTimeTracker = ctrl.startDate;
            $state.go('application.programsInstance', { id: item.entity.id });
          }
        },

        onDataGridPaginate: function (newPage, pageSize, sortField, sortDirection) {
          ctrl.gridState.updateGridState(newPage, pageSize);
          if (sortField) {
            ctrl.gridState.updateGridState(null, null, sortField, null);
          }
          if (sortDirection) {
            ctrl.gridState.updateGridState(null, null, null, sortDirection);
          }
          ctrl.search();
        },

        onDataGridSortChange: function (grid, columns, page) {
          const data = columns[0];
          ctrl.gridState.updateGridState(page || null, null, data.field, data.sort.direction);
          ctrl.search();
        },

        onDataGridSelectionChange: function (row, e) {
          if (row.isSelected) {
            ctrl.selected = row.entity;
            ctrl.getEvent(row.entity);
          }
        },

        onItemCountUpdated: function (n, o) {
          if (!ctrl.model || n !== o) {
            ctrl.refresh();
          }
        },

        onCartServiceInitted: function (n, o) {
          if (n !== o) {
            ctrl.refresh();
          }
        },

        onAdvancedFiltersClear: function () {
          ctrl.paramsCustomFields.fields = [];
          ctrl.paramsCustomFields.operator = 'and';

          // Always use basic search when clearing advanced filters
          this.gridState.setPropertyValue('search', this.searchQuery);
          $scope.$broadcast('DataGrid::Search', { name: this.eventListGridName });
        },

        onAdvancedFiltersSubmit: function (props: {
          rawFilters: Record<string, any>;
          fields: Array<any>;
          operator: string;
        }) {
          ctrl.paramsCustomFields.fields = props.fields;
          ctrl.paramsCustomFields.operator = props.operator;

          this.gridState.setPropertyValue('search', this.searchQuery);
          $scope.$broadcast('DataGrid::Search', { name: this.eventListGridName });

          sidebarService.hide();
        },

        onAdvancedFiltersClose: function () {
          sidebarService.hide();
        },
      };

      $scope.programsList = ctrl;
      ctrl.init();
    },
  ])
  .controller('ProgramsListDatePickerController', [
    '$scope',
    '$timeout',
    'UserPreferencesService',
    function (
      $scope: IScope & { programsListDatePicker: TODO; dt: TODO; minDate: TODO },
      $timeout: ITimeoutService,
      UserPreferencesService: UserPreferencesService,
    ) {
      const ctrl = {
        isOpen: false,

        dateOptions: {
          formatYear: 'yy',
          startingDay: UserPreferencesService.getStartDayOfWeek(),
          formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
          showWeeks: false,
        } as {
          formatYear: string;
          startingDay: string;
          formatDayTitle: string;
          showWeeks?: boolean;
        },
        isPreferenceLoaded: false,
        init: function () {
          $scope.$on('UserPreferencesService:onDateFormatLoad', ctrl.onDateFormatLoad);
          $timeout(function () {
            ctrl.isPreferenceLoaded = true;
          }, 0);
        },

        today: function () {
          this.dt = new Date();
        },
        clear: function () {
          $scope.dt = null;
        },

        toggleMin: function () {
          $scope.minDate = $scope.minDate ? null : new Date();
        },
        open: function ($event) {
          $event.preventDefault();
          $event.stopPropagation();

          this.isOpen = true;
        },

        onDateFormatLoad: function (e, data) {
          ctrl.dateOptions = {
            formatYear: 'yy',
            startingDay: UserPreferencesService.getStartDayOfWeek(),
            formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
          };
        },
      };

      $scope.programsListDatePicker = ctrl;
      ctrl.init();
    },
  ]).name;
